import moment from 'moment';
// Validation Methods
export const validateText = (text) => {
  if (/^[a-zA-Z.\- ]{1,}$/.test(text)) {
    return true;
  }
  return false;
};
export const validateAlphanumericText = (text) => {
  if (/^[a-zA-Z0-9!@#$&()/\-`'.+," ]{1,}$/.test(text)) {
    return true;
  }
  return false;
};

export const validatePanInput = (panNumber) => {
  if (/^[a-zA-Z0-9]{0,10}$/.test(panNumber)) {
    return true;
  }
  return false;
};

export const validateAlphanumericTextIfsc = (text) => {
  if (/^[a-zA-Z0-9]{11}$/.test(text)) {
    return true;
  }
  return false;
};
export const validateAlphanumericTextCompany = (text) => {
  if (/^[a-zA-Z0-9!@#$&()/\-`'.+," ]{2,}$/.test(text)) {
    return true;
  }
  return false;
};
export const validateTextForSearchInput = (text) => {
  if (/^.*\S.*$/.test(text)) {
    return true;
  }
  return false;
};

export const validateAccountNumbers = (bankAccountNo, reaccountNumber) => {
  if (bankAccountNo !== reaccountNumber) {
    return true;
  }
  return false;
};

export const validateAccountNo = (text) => {
  if (/^-?\d{6,18}$/.test(text)) {
    return true;
  }
  return false;
};

export const validate20DigitAccountNo = (text) => {
  if (/^-?\d{6,20}$/.test(text)) {
    return true;
  }
  return false;
};

export const validateReAccountNo = (text, accountNo) => {
  console.log('accountNo', text, accountNo);
  if (/^-?\d{6,18}$/.test(text) && text === accountNo) {
    return true;
  }
  return false;
};

export const validate20DigitReAccountNo = (text, accountNo) => {
  console.log('accountNo', text, accountNo);
  if (/^-?\d{6,20}$/.test(text) && text === accountNo) {
    console.log('accountNo', true);
    return true;
  }
  console.log('accountNo', false);
  return false;
};

export const validateIfscCode = (text) => {
  if (/^[A-Z]{4}0[A-Z0-9]{6}$/.test(text)) {
    return true;
  }
  return false;
};

export const validateUpiId = (text) => {
  if (/^\w+@\w+$/.test(text)) {
    return true;
  }
  return false;
};

export const validateDate = (text) => {
  if (
    /^(19[5-9][0-9]|20[0-4][0-9]|2050)[-/](0?[1-9]|1[0-2])[-/](0?[1-9]|[12][0-9]|3[01])$/.test(
      text
    )
  ) {
    return true;
  }
  return false;
};

export const validateTextWithSplChars = (text) => {
  if (/^[-a-zA-Z. ]{1,}$/.test(text)) {
    return true;
  }
  return false;
};

export const validateMobile = (number) => {
  if (/^[56789][0-9]{9}$/.test(number)) {
    return true;
  }
  return false;
};

export const validateCurrency = (number) => {
  if (/^[1-9][0-9,]{1,}$/.test(number)) {
    return true;
  }
  return false;
};

export const validateOtp = (otp) => {
  if (/^[0-9]{6}$/.test(otp)) {
    return true;
  }
  return false;
};
export const validateZipCode = (otp) => {
  if (/^[0-9]{4}$/.test(otp)) {
    return true;
  }
  return false;
};
export const validateAddressText = (text) => {
  if (text.length > 0) {
    return true;
  }
  return false;
};
export const validateNumber = (number) => {
  if (/^\d+$/.test(number)) {
    return true;
  }
  return false;
};
export const validateNumberWithDecimal = (number) => {
  if (/^\d+(\.\d{1,2})?$/.test(number)) {
    return true;
  }
  return false;
};
export const validateYear = (number) => {
  if (/^\d+(\.\d{1,2})?$/.test(number)) {
    return true;
  }
  return false;
};
export const validateEmail = (email) => {
  const re =
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(String(email).toLowerCase());
};

export const validateEmailOffice = (email) => {
  const reg =
    /^([\w-.]+@(?!gmail\.com)(?!yahoo\.com)(?!yahoo\.in)(?!ymail\.com)(?!hotmail\.com)(?!rediff\.com)(?!rediffmail\.com)(?!mail\.ru)(?!yandex\.ru)(?!mail\.com)([\w-]+.)+[\w-]{2,4})?$/;
  if (reg.test(String(email).toLowerCase())) {
    const re =
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
  }
  return false;
};

export const validateURL = (url) => {
  const reg =
    /^(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_+.~#?&//=]*)/;
  return reg.test(String(url).toLowerCase());
};

export const validatePan = (panNumber) => {
  if (
    /^([a-zA-Z]){5}([0-9]){4}([a-zA-Z]){1}?$/.test(panNumber) &&
    panNumber.charAt(3) === 'P'
  ) {
    return true;
  }
  return false;
};

export const validatePincode = (pinCode) => {
  if (/^[1-9][0-9]{5}$/.test(pinCode)) {
    return true;
  }
  return false;
};

export const validateAddress = (address) => {
  if (address !== '') {
    return true;
  }
  console.log('Invalid Address');
  return false;
};

export const validateDOB = (date) => {
  if (date.length < 14) return false;
  const formatedDate = date.replace(/ /g, '');
  const dateParts = formatedDate.split('/');
  const userDate = new Date(dateParts[2], dateParts[1] - 1, dateParts[0]);
  const currentDate = new Date();
  const minimumPossibleDate = new Date(
    `${new Date().getFullYear() - 100}`,
    '0',
    '1'
  );
  if (userDate > currentDate || userDate < minimumPossibleDate) return false;
  if (
    !/^(?:(?:31(\/|-|\.)(?:0?[13578]|1[02]))\1|(?:(?:29|30)(\/|-|\.)(?:0?[13-9]|1[0-2])\2))(?:(?:1[6-9]|[2-9]\d)?\d{2})$|^(?:29(\/|-|\.)0?2\3(?:(?:(?:1[6-9]|[2-9]\d)?(?:0[48]|[2468][048]|[13579][26])|(?:(?:16|[2468][048]|[3579][26])00))))$|^(?:0?[1-9]|1\d|2[0-8])(\/|-|\.)(?:(?:0?[1-9])|(?:1[0-2]))\4(?:(?:1[6-9]|[2-9]\d)?\d{2})$/.test(
      formatedDate
    )
  )
    return false;
  return true;
};

export const validateName = (input) => {
  if (/^([^0-9]*)$/.test(input) && input.length > 0) return true;
  return false;
};

export const validateAadhar = (val) => {
  if (/^[0-9]{12}$/.test(val)) {
    return true;
  }
  return false;
};

export const validate4DigitAadhar = (val) => {
  if (/^[0-9]{4}$/.test(val)) {
    return true;
  }
  return false;
};

export const validateVoterId = (val) => {
  if (/^([a-zA-Z]){3}([0-9]){7}?$/.test(val)) {
    return true;
  }
  return false;
};

export const validatePassPortId = (val) => {
  if (/^[A-Z]{1}[0-9]{19}$/.test(val)) {
    return true;
  }
  return false;
};
export const validateDrivingLicenseId = (val) => {
  if (
    /^(([A-Z]{2}[0-9]{2})( )|([A-Z]{2}-[0-9]{2})|([A-Z]{2}[0-9]{3})|([A-Z]{2}[0-9]{2}[A-Z]{1}))((19|20)[0-9][0-9])[0-9]{7}$/.test(
      val
    )
  ) {
    return true;
  }
  return false;
};

// For DL, passport, Voter id
export const validateDoc = (val) => {
  // if (/^([A-Z]{2})(\d{2}|\d{3})\s?[a-zA-Z]{0,1}(\d{4})(\d{7})$/.test(val)) {
  if (/^[a-zA-Z0-9/\-\\()&@,. ]{1,20}$/.test(val)) {
    return true;
  }
  return false;
};

export const validateExpiryCard = (val) => {
  if (/^(0[1-9]|1[0-2])\/?([0-9]{2})$/.test(val)) {
    return true;
  }
  return false;
};

export const validateIfscCodeNew = (val) => {
  if (/^([A-Z]{4}0[A-Z0-9]{6})$/.test(val)) {
    return true;
  }
  return false;
};
export const validateAlphanumericIdNumber = (text) => {
  if (/^[a-zA-Z0-9@&()/\-.,/ ]{1,20}$/.test(text)) {
    return true;
  }
  return false;
};

export const validateUserName = (val) => {
  // This regular expression matches strings that only contain letters,
  // and spaces, and do not start with a space.
  const regex = /^[a-zA-Z][a-zA-Z\s]*$/;
  return regex.test(val);
};

export const validateDocExpiryDate = (expDate) => {
  let currentMonth = new Date().getMonth() + 1;
  let currentYear = new Date().getFullYear();
  let minDate = `${currentMonth === 12 ? currentYear + 1 : currentYear}-${
    currentMonth === 12 ? '01' : ('0' + (currentMonth + 1)).slice(-2)
  }-01`;
  //   let maxDate = `${currentMonth === 12 ? currentYear + 16 : currentYear + 15}-${
  //     currentMonth === 12 ? '01' : ('0' + (currentMonth + 1)).slice(-2)
  //   }-01`;
  let twentyYearsFromNow = new Date();
  let today = new Date();
  twentyYearsFromNow.setFullYear(today.getFullYear() + 20);
  console.log(
    twentyYearsFromNow.toLocaleDateString('en-US', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
    })
  );
  console.log('maxDate', twentyYearsFromNow);

  let date = expDate.split('/').join('-'); // for safari browser Facing issue then i apply custom changes formate
  let date2 = date.split('-');
  let newDate = `${date2['2']}-${date2['1']}-${date2['0']}`;

  let minDateTimeStamp =
    Date.parse(moment(new Date(minDate)).format('YYYY-MM-DD')) / 1000;
  let maxDateTimeStamp =
    Date.parse(moment(new Date(twentyYearsFromNow)).format('YYYY-MM-DD')) /
    1000;
  let currentDateTimeStamp =
    Date.parse(moment(new Date(newDate)).format('YYYY-MM-DD')) / 1000;

  console.log('minDate', minDate, minDateTimeStamp);
  console.log('maxDate', twentyYearsFromNow, maxDateTimeStamp);
  console.log('currentDate', expDate, currentDateTimeStamp);

  if (
    minDateTimeStamp <= currentDateTimeStamp &&
    maxDateTimeStamp >= currentDateTimeStamp
  ) {
    return true;
  }
  return false;
};
